import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as authApi from '../../lib/api/auth';


const [LIST_USER_SCHEDULES, LIST_USER_SCHEDULES_SUCCESS, LIST_USER_SCHEDULES_FAILURE] =
  createRequestActionTypes('user/LIST_USER_SCHEDULES');
export const listSchedules = createAction(LIST_USER_SCHEDULES, (searchData)=>(searchData));
const listSchedulesSaga = createRequestSaga(LIST_USER_SCHEDULES, authApi.getSchedules);

const UNLOAD_USER_SCHEDULES = 'user/UNLOAD_USER_SCHEDULES';
export const unloadUserSchedules = createAction(UNLOAD_USER_SCHEDULES);

export function* schedulesSaga() {
  yield takeLatest(LIST_USER_SCHEDULES, listSchedulesSaga);
}

const initialState = {
  schedules: null,
  error: null,
};

// 비주얼 리뉴얼(2026-10-23) - 일정 종류별 색("영업"/"기술지원"/"휴가·근태" 구분, item 5).
// 백엔드(ScheduleMapper.selectScheduleList)는 지금 "tech"(기술지원)만 내려주므로(PMS_TECH_PLN
// 기반 - ScheduleDTO 주석의 'vacation' 등은 예전 mock 흔적일 뿐 실제 쿼리에는 없다) sales/vacation
// 분기는 실제로는 안 타지만, 나중에 백엔드가 그 타입들을 내려줄 때를 대비해 매핑만 넓혀 둔다.
const TYPE_COLOR = {
  tech: '#f59e0b', // 기술지원
  sales: '#1976d2', // 영업(데이터 없음 - 대비만 해둠)
  vacation: '#9e9e9e', // 휴가·근태(데이터 없음 - 대비만 해둠)
  leave: '#9e9e9e',
};
const colorForType = (type) => TYPE_COLOR[type] || '#ffcf33';

const schedules = handleActions(
  {
    [LIST_USER_SCHEDULES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      schedules: data.list.map((schedule) => ({
        id:schedule.id,
        type:schedule.type,
        taskUuid:schedule.taskUuid,
        title:schedule.title,
        allDay:schedule.allDay,
        start:schedule.start,
        end:schedule.end,
        usrNm:schedule.usrNm,
        gradeNm:schedule.gradeNm,
        dptNm:schedule.dptNm,
        backgroundColor:colorForType(schedule.type),
        borderColor:colorForType(schedule.type)
      })),
      error: null,
    }),
    [LIST_USER_SCHEDULES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_USER_SCHEDULES]: (state) => ({
      ...state,
      schedules: null,
      error: null,
    }),
  },
  initialState,
);

export default schedules;
